//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBoardWithAllFieldsBelow from '../rb-board-with-fields-below/rb-board-with-fields-below.vue'
export default {
  name: 'rb-board-with-fields-on-stacked-mobile',
  extends: RbBoardWithAllFieldsBelow,
}
